import { createSlice } from "@reduxjs/toolkit";

const token = localStorage.getItem("token");
const user = localStorage.getItem("user");

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: token || "",
    user: user || '',
  },
  
  reducers: {
    
    login(state, action) {
      state.token = action.payload;
      state.user = action.payload;
    }, 
    logout(state) {
      state.token = "";
    },
    
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
